import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_maintain_recorded_parental_permission_for_wrkrs_un'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_maintain_recorded_parental_permission_for_wrkrs_un',
  name: 'Does the facility maintain recorded parental permission for workers under the age of 18 to work in the facility?',
  description:
    'The intent of this question is to understand if parental permission is maintained by the facility (regardless of what the law states). \r\r\n\r\r\nParental permissions refer to permission from the parent(s)\r\r\n\r\r\nMaintain refers to the facility keeping on file original or photocopied evidence of the permission from the parent(s). Recorded refers to in writing or some other permanent form for later reference.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'cl-4--1',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 4490,
  sectionId: '2.2.1',
  impactArea: 'Child Labour',
  impactAreaId: 'CHILD_LABOR',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
